import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 's1-card',
    templateUrl: './s1-card.component.html',
    styleUrls: ['./s1-card.component.scss'],
    standalone: false
})
export class S1Card implements OnInit {

  @Input() title: string;
  @Input() alignTitleCenter:boolean = true;
  @Input() headerStyle: string = "bg-dark text-light";
  @Input() bottomPadding: boolean = true;
  @Input() cardStyle: string;

  constructor() { }

  ngOnInit(): void { }

}
